<template>
  <div>
    <div class="sidenav-overlay"></div>
    <div class="drag-target"></div>
    <footer class="footer footer-static footer-light">
      <p class="clearfix mb-0"><span class="float-md-left d-block d-md-inline-block mt-25">COPYRIGHT &copy; 2021<a
          class="ml-25" href="https://vaultspay.com/" target="_blank" @click="$router.push({name:'dashboard-overview'})">VaultsPay</a><span
          class="d-none d-sm-inline-block">, All rights Reserved</span></span></p>
    </footer>
<!--    <button class="btn btn-primary btn-icon scroll-top" type="button"><BIconArrowUp /></button>-->
  </div>
</template>

<script>
export default {
  mounted() {
  },
  data() {
    return {}
  }
}
</script>

